module.exports = __webpack_public_path__ + "img/ba.d0289dc0.png";